import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BUTTONS } from "@/utils/constants/appConstants/commonConstants";

type ConfirmationModalProps = {
    show: boolean;
    setShow: (show: boolean) => void;
    title: string;
    message: string;
    onConfirm: () => void;
};

const ConfirmationModal = ({ show, setShow, title, message, onConfirm }: ConfirmationModalProps) => {
    const handleClose = () => setShow(false);

    return (
        <Dialog
            open={show}
            onOpenChange={(open) => {
                if (!open) handleClose();
            }}
        >
            <DialogContent className="gs-confirm-dialog">
                <div className="gs-confirm-dialog__header">
                    <h4 className="gs-confirm-dialog__title">{title}</h4>
                </div>

                <div className="gs-confirm-dialog__body">
                    <p>{message}</p>
                </div>

                <div className="gs-confirm-dialog__footer gs-confirm-dialog__footer--actions">
                    <Button type="button" variant="light" onClick={handleClose}>
                        {BUTTONS.CANCEL}
                    </Button>
                    <Button type="button" variant="destructive" onClick={onConfirm}>
                        {BUTTONS.CONFIRM}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ConfirmationModal;
